import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, normalizeStyle as _normalizeStyle, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-01bd397d")
const _hoisted_1 = { class: "options-bar-wrapper" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "disalbed-icon" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "btn-text" }, "禁用", -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "enabled-icon" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "btn-text" }, "启用", -1)
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "logout-icon" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "btn-text" }, "退出登录", -1)
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "vocal-balance-icon" }, null, -1)
_popScopeId()

import { computed, ref } from "vue";
import volumeSlider from "./volumeSlider.vue";
import _ from "lodash";
interface OptionsBarProps {
  showVocalBalance: boolean;
  volume: number;
  mute: boolean;
}


export default _defineComponent({
  props: {
    showVocalBalance: { type: Boolean, required: true, default: false },
    volume: { type: Number, required: true, default: 60 },
    mute: { type: Boolean, required: true, default: false }
  } as unknown as undefined,
  emits: ["setEnabled", "setDisabled", "setLogout", "update:showVocalBalance", "updateVolume", "updateMute"] as unknown as undefined,
  setup(__props: {
  showVocalBalance: boolean;
  volume: number;
  mute: boolean;
}, { emit }: { emit: ({
  (event: "setEnabled"): void;
  (event: "setDisabled"): void;
  (event: "setLogout"): void;
  (event: "update:showVocalBalance", visible: boolean): void;
  (event: "updateVolume", volume: number): void;
  (event: "updateMute", mute: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props




const balanceVisible = computed<boolean>(() => props.showVocalBalance);

const volume = computed<number>(() => props.volume);
const mute = computed<boolean>(() => props.mute);

const updateVolume = (val: number) => {
  emit("updateVolume", val);
};
const updateMute = (val: boolean) => {
  emit("updateMute", val);
};

const handleSetDisabled = _.throttle(() => {
  emit("setDisabled");
}, 500);

const handleSetEnabled = _.throttle(() => {
  emit("setEnabled");
}, 500);

const handleSetLogout = _.throttle(() => {
  emit("setLogout");
}, 500);

const handleSetBalance = _.throttle(() => {
  emit("update:showVocalBalance", !balanceVisible.value);
}, 500);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "disabled-btn",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(handleSetDisabled) && _unref(handleSetDisabled)(...args)))
    }, _hoisted_4),
    _createElementVNode("div", {
      class: "enabled-btn",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(handleSetEnabled) && _unref(handleSetEnabled)(...args)))
    }, _hoisted_7),
    _createElementVNode("div", {
      class: "logout-btn",
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(handleSetLogout) && _unref(handleSetLogout)(...args)))
    }, _hoisted_10),
    _createElementVNode("div", {
      class: "vocal-balance-btn",
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(handleSetBalance) && _unref(handleSetBalance)(...args)))
    }, [
      _hoisted_11,
      _createElementVNode("div", {
        style: _normalizeStyle(__props.showVocalBalance ? { color: '#ff7753' } : {}),
        class: "btn-text"
      }, " 人声均衡 ", 4)
    ]),
    _createVNode(volumeSlider, {
      value: _unref(volume),
      mute: _unref(mute),
      onUpdateMute: updateMute,
      onUpdateValue: updateVolume
    }, null, 8, ["value", "mute"])
  ]))
}
}

})